/* eslint-disable tss-unused-classes/unused-classes */

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  button: {
    margin: `${theme.spacing(0.5)} 0`,
    padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
    height: 40,
    borderRadius: 20,
  },
  container: {
    display: 'flex',
    flex: 1,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    '& .MuiCheckbox-root': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  card: {
    background: theme.palette.background.default,
    border: `1px ${theme.palette.border.light} solid`,
    '& .MuiCardHeader-root': {
      height: 52,
      borderBottom: `1px solid ${theme.palette.border.light}`,
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
    marginTop: 0,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
    '> .MuiStack-root': {
      flex: 1,
    },
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  column: {
    paddingLeft: 42,
    marginTop: -4,
  },
  selected: {
    color: theme.palette.primary.main,
  },
  imgClass: {
    height: 16,
    width: 16,
    '&.singleIcon': {
      marginTop: -2,
    },
    alignSelf: 'center',
  },
  innerCard: {
    border: `1px ${theme.palette.border.main} solid`,
    borderRadius: 12,
    background: theme.palette.background.paper,
    padding: theme.spacing(2),
  },
  notesTargetContainer: {
    display: 'flex',
    flex: 1,
    margin: 0,
    '.MuiInputBase-root': {
      background: theme.palette.background.paper,
      padding: theme.spacing(1),
    },
  },
  tagsTargetContainer: {
    border: `1px ${theme.palette.border.main} solid`,
    borderRadius: 12,
    background: theme.palette.background.paper,
    padding: theme.spacing(2),
  },
  categoryTargetContainer: {
    '.MuiFilledInput-root': {
      height: '52px',
      boxSizing: 'border-box',
      background: theme.palette.background.paper,
      padding: theme.spacing(2),
      input: {
        padding: 0,
      },
    },
  },
  usageTargetContainer: {
    '.MuiFilledInput-root': {
      background: theme.palette.background.paper,
      paddingRight: theme.spacing(2),
      height: '52px',
    },
  },
  accountTargetContainer: {
    display: 'flex',
    flex: 1,
    '.MuiTextField-root': {
      flex: 1,
    },
  },
  accountTarget: {
    background: theme.palette.background.paper,
    alignItems: 'center',
    input: {
      padding: theme.spacing(2),
    },
  },
  payeeFieldContainer: {
    '.MuiTextField-root': {
      margin: 0,
      padding: 0,
      '.MuiFilledInput-root': {
        height: '52px',
        boxSizing: 'border-box',
        background: theme.palette.background.paper,
        padding: theme.spacing(2),
        input: {
          padding: 0,
        },
      },
    },
  },
  addBtnRow: {
    display: 'flex',
    flex: 1,
    gap: 16,
    '> hr': {
      flex: 1,
      alignSelf: 'center',
    },
  },
  formControlLabel: {
    margin: 0,
    padding: 0,
  },
  ruleAmount: {
    '.MuiInputBase-formControl': {
      background: theme.palette.background.paper,
    },
    '.MuiInputAdornment-filled': {
      margin: '0 !important',
    },
    '.MuiFilledInput-input': {
      padding: `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(0.5)} `,
    },
  },
  amountRange: {
    display: 'flex',
    gap: 0,
    '#amount-match-amount1 .MuiInputBase-root': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    '#amount-match-amount2': {
      marginLeft: -1,
      '.MuiInputBase-root': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      },
    },
  },
  textPaddingBefore: {
    marginLeft: theme.spacing(1),
  },
  highlightText: {
    color: theme.palette.primary.main,
  },
  infoIcon: {
    color: theme.palette.icon.light,
    height: theme.spacing(1.5),
    width: theme.spacing(1.5),
  },
  inputStyle: {
    textAlign: 'left',
    padding: 0,
  },
  textField: {
    display: 'flex',
    justifyContent: 'flex-start',
    borderRadius: theme.spacing(1.5),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    background: theme.palette.background.paper,
    border: `1px ${theme.palette.border.main} solid`,
  },
  warningIcon: {
    alignSelf: 'top',
    marginRight: 5,
    color: theme.palette.warning.main,
    width: 20,
    height: 20,
  },
}));

export default useStyles;
